<template>ResidenceMedicationManagement">
    <div class="container-fluid">
        <div class="row" style="margin-top: 10px;">
            <div class="col">
                <div class="record-tabs">
                    <span class="d-none d-sm-block">
                        <b-nav>
                            <div v-for="pane in Panes">
                                <b-nav-item v-on:click="ChangePaneShown(pane.name)" v-bind:class="{ active: PaneShown == pane.name }">{{pane.name}}</b-nav-item>
                            </div>
                        </b-nav>
                    </span>
                    <b-nav>
                        <span class="d-sm-none">
                            <b-nav-item-dropdown :text=changeDropdownName id="mobileDropdown">
                                <div v-for="pane in Panes">
                                    <b-dropdown-item v-on:click="ChangePaneShown(pane.name)" v-bind:class="{ active: PaneShown == pane.name }">{{pane.name}}</b-dropdown-item>
                                </div>
                            </b-nav-item-dropdown>
                        </span>
                    </b-nav>
                </div>
                <div class="tab-content">
                    <div v-if="PaneShown == 'DISPENSATION PLAN'">
                        <DailyResidentialDispensationPlan v-bind:residence-id="ResidenceId" />
                    </div>
                    <div v-if="PaneShown == 'COUNT'">
                        <ResidentialInventoryCount v-bind:residence-id="ResidenceId" />
                    </div>
                        
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    //import components
    import DailyResidentialDispensationPlan from './DailyResidentialDispensationPlan.vue';
    import ResidentialInventoryCount from './ResidentialInventoryCount.vue';
    export default {
        props: [
            'ResidenceId'
        ],
        data: function () {
            return {
                PaneShown: "DISPENSATION PLAN",
                Panes: [
                    { name: 'DISPENSATION PLAN' },
                    { name: 'COUNT' }
                ]
            };
        },
        methods: {
            ChangePaneShown(paneName) {
                this.PaneShown = paneName;
            },
            formatDate(value, fmt = 'MM/DD/YY', defaultText = '') {
                return (value == null)
                    ? defaultText
                    : moment(value, 'YYYY-MM-DD').format(fmt)
            }
        },
        components: {
            DailyResidentialDispensationPlan,
            ResidentialInventoryCount
        },
        mounted() {

        },
        computed: {
            changeDropdownName: function () {
                return this.PaneShown;
            }
        },
    }
</script>

<style scoped>
    .record-tabs {
        width: 100%;
        display: inline-block;
    }

    @media only screen and (max-width: 576px) {
        h4 {
            font-size: 1em;
        }

        h1 {
            font-size: 1.5em;
        }
    }

    li a {
        color: black !important;
    }

    li.active a {
        color: black !important;
    }
</style>